export default {
  signupSession (state) {
    return state.signupSession
  },
  firstName (state) {
    return state.firstName
  },
  lastName (state) {
    return state.lastName
  },
  email (state) {
    return state.email
  },
  password (state) {
    return state.password
  },
  birthdate (state) {
    return state.birthdate
  },
  country (state) {
    return state.country
  },
  state (state) {
    return state.state
  },
  streetName (state) {
    return state.streetName
  },
  city (state) {
    return state.city
  },
  zipCode (state) {
    return state.zipCode
  },
  acceptsTerms (state) {
    return state.acceptsTerms
  },
  acceptsPrivacy (state) {
    return state.acceptsPrivacy
  },
  divisions (state) {
    return state.divisions
  },
  stripeClientSecret (state) {
    return state.stripeClientSecret
  },
  guardianFirstName (state) {
    return state.guardianFirstName
  },
  guardianLastName (state) {
    return state.guardianLastName
  },
  guardianEmail (state) {
    return state.guardianEmail
  },
  guardianConsent (state) {
    return state.guardianConsent
  },
  guardianVideoConsent (state) {
    return state.guardianVideoConsent
  }
}
